import "./index.css";
import Textarea from "../../../layout/Textarea/Textarea";
import {useEdits} from "../../../contexts/edits";
import {useSetting} from "../../../contexts/setting";
import {useImages} from "../../../contexts/images";
import BgTransformer from "../../../layout/BgTransformer";
import adsAssets from "../../../data/ads-assets.json";

const SoMeHorizontalAds = ({id, zoom}) => {
  const {channel, product, type, bgOption, locked} = useSetting();
  const {customBgs} = useImages();
  const isLocked = locked.some((x) => x === id);
  // Per-template custom bg wins over the shared one (only when locked);
  // unlocking falls back to .main automatically.
  const customBgUrl = (isLocked ? customBgs[id] : undefined) || customBgs.main || null;
  const {titles, subtitles} = useEdits();
  const title = titles[id] || titles.main;
  const subtitle = subtitles[id] || subtitles.main;

  // Per-template baked PNG, served from the v3 uploads CDN. The manifest at
  // src/data/ads-assets.json is auto-generated by
  // scripts/bake-ads-backgrounds.mjs (which uploads each baked PNG and
  // records the returned CDN URL keyed on
  // `<channel>/<product>/<contentType>/<bgVariation>/<templateId>`).
  // Manifest miss is expected during channel-switch transitions (URL params
  // updated before useSetting commits) and for combos that haven't been baked
  // yet. Soft-fall-through: skip the background rather than crashing the page.
  const bgIdx = bgOption || 1;
  const assetKey = `${channel.value}/${product.value}/${type.value}/${bgIdx}/${id}`;
  const bgUrl = adsAssets[assetKey]?.url;

  return (
    <div id={id} className={`template ${type.value} tpl-card`} style={{"--zoom-level": zoom}}>
      {/* Keep background and foreground content in one positioning context. */}
      <div className="tpl-card__inner">
        {customBgUrl || bgUrl ? <BgTransformer src={customBgUrl || bgUrl} id={id} /> : null}
        <div className="tpl-bubble">
          <h2 className="subtitle">
            <Textarea id={id} text={subtitle} />
          </h2>
          {/* Tail path. AI variant uses Vector 1 from Figma node 2044:20
           * (inlined verbatim, fill via currentColor matching the bubble's
           * solid color). DevEco variant uses Vector 1 from node 2044:11 and
           * fills via a userSpaceOnUse linearGradient aligned to the bubble's
           * coord frame so the gradient continues seamlessly across rect+tail
           * (same approach as BlogPostAds). Two SVGs (one per content type)
           * because the viewBoxes differ — AI 48×55, deveco 53×61. */}
          {type.value === "deveco" ? (
            <svg
              className="tpl-bubble__tail"
              viewBox="0 0 53 61"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <defs>
                <linearGradient
                  id="SoMeHorizontalAds-deveco-tail-gradient"
                  gradientUnits="userSpaceOnUse"
                  x1="13.589"
                  y1="-102.364"
                  x2="508.619"
                  y2="49.410"
                >
                  <stop offset="0" stopColor="#211104" />
                  <stop offset="1" stopColor="#472407" />
                </linearGradient>
              </defs>
              <path
                d="M0 60.6076C0 60.6076 13.6935 23.8373 13.6935 0L52.9999 28.6555C33.4736 51.732 0 60.6076 0 60.6076Z"
                fill="currentColor"
              />
            </svg>
          ) : (
            <svg
              className="tpl-bubble__tail"
              viewBox="0 0 48 55"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M0 54.89C0 54.89 12.4016 21.5885 12.4016 0L48 25.9522C30.3157 46.8517 0 54.89 0 54.89Z"
                fill="currentColor"
              />
            </svg>
          )}
        </div>
        <h1 className="title">
          <Textarea id={id} text={title} />
        </h1>
      </div>
    </div>
  );
};

export default SoMeHorizontalAds;
